export interface HeroSlide {
  id: string;
  image: string;
  eyebrow: string;
  title: string;
  subtitle: string;
  link: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "1",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20film%20set%20with%20dramatic%20warm%20orange%20lighting%2C%20camera%20crew%20silhouettes%2C%20atmospheric%20haze%2C%20grand%20scale%20production%2C%20dark%20moody%20background%2C%20no%20text&width=1920&height=1080&seq=mango-hero-01&orientation=landscape",
    eyebrow: "影视内容制作 · 传媒服务",
    title: "用影像记录时代，用内容连接人心",
    subtitle: "芒果传媒，中国领先的影视内容制作与传媒平台，十八年专注优质内容创作。",
    link: "/works",
  },
  {
    id: "2",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20broadcast%20studio%20with%20large%20screens%20and%20warm%20amber%20stage%20lighting%2C%20professional%20production%20environment%2C%20depth%20of%20field%2C%20dark%20elegant%20atmosphere%2C%20no%20text&width=1920&height=1080&seq=mango-hero-02&orientation=landscape",
    eyebrow: "节目策划 · 模式研发",
    title: "从洞察出发，打造有记忆点的节目",
    subtitle: "专业的综艺与纪实内容团队，让每一个创意都能被完整地呈现在观众面前。",
    link: "/services",
  },
  {
    id: "3",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20light%20rays%20and%20film%20reels%20in%20warm%20golden%20tones%2C%20artistic%20media%20concept%2C%20deep%20dark%20background%2C%20elegant%20atmosphere%2C%20no%20text&width=1920&height=1080&seq=mango-hero-03&orientation=landscape",
    eyebrow: "内容发行 · 全球传播",
    title: "让好内容，抵达更远的地方",
    subtitle: "覆盖国内外主流渠道的发行网络，让优秀的作品被更多观众看见。",
    link: "/about",
  },
];

export interface ContactInfo {
  address: string;
  phone: string;
  email: string;
  hours: string;
  mapEmbed: string;
}

export const contactInfo: ContactInfo = {
  address: "上海市徐汇区滨江大道 1388 号传媒大厦 18 层",
  phone: "021-6688-1688",
  email: "contact@mangomedia.com",
  hours: "周一至周五 09:00 - 18:00",
  mapEmbed:
    "https://et22.cn/maps?q=Shanghai%20Xuhui%20Riverside&output=embed",
};

export const socialLinks = [
  { name: "微信公众号", icon: "ri-wechat-line", href: "#" },
  { name: "微博", icon: "ri-weibo-line", href: "#" },
  { name: "抖音", icon: "ri-tiktok-line", href: "#" },
  { name: "哔哩哔哩", icon: "ri-bilibili-line", href: "#" },
];

export const navLinks = [
  { name: "首页", path: "/" },
  { name: "关于我们", path: "/about" },
  { name: "服务", path: "/services" },
  { name: "作品案例", path: "/works" },
  { name: "新闻动态", path: "/news" },
  { name: "联系我们", path: "/contact" },
];